<template>
    <div class="login">
        <div class="container">
            <el-card :body-style="{ padding: '0px', 'border-radius': '5px' }">
                <div style="padding: 20px;">
                    <img src="../assets/NOTAXI.png" class="image"/>
                    <div class="input-container">
                        <el-input
                                v-model="email"
                                placeholder="Email"></el-input>
                        <el-input
                                v-model="password"
                                placeholder="Password" show-password></el-input>
                        <el-button
                                v-loading.fullscreen.lock="loading"
                                :disabled="disabledLogin" type="primary" style="margin: 20px 0" @click="onLogin">
                            Login
                        </el-button>
                    </div>
                </div>
            </el-card>
        </div>
    </div>
</template>

<script>

    import LoginService from '@/common/services/login.service'
    import CommonUtils from "../common/services/CommonUtils";
    import {validateEmail} from "../common/services/regular-expressions";

    export default {
        name: 'Login',
        data() {
            return {
                email: null,
                password: null,
                loading: false
            }
        },

        computed: {
            disabledLogin() {
                if (!this.email || !this.password) {
                    return true
                }
                return this.email.length <= 3 || !validateEmail(this.email);

            }
        },
        methods: {
            onLogin() {
                this.loading = true;
                let payload = {
                    email: this.email,
                    password: this.password
                };
                LoginService.login(payload).then(res => {
                    let response = res.data;
                    document.cookie = 'role=' + response.role;
                    document.cookie = 'user_email=' + this.email;
                    document.cookie = 'token=' + response.authToken;
                    this.$router.push({
                        name: 'Dashboard'
                    });
                }).catch(er => {
                    this.$notify.error({
                        title: `Failed to login`,
                        message: er.response.data.message
                    });
                }).finally(() => this.loading = false)

            }
        },
        beforeMount() {
            let user = CommonUtils.getCookie('user_email');
            if (user) {
                this.$router.push({
                    name: 'Dashboard'
                });
            }

        }
    }
</script>


<style scoped lang="scss">
    .login {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 90vh;

        .container {
            padding: 20px;

            .image {
                height: 150px;
                width: 170px;
            }

            .input-container {
                display: flex;
                flex-direction: column;
                min-width: 400px;
                padding: 20px;
            }
        }
    }
</style>
